<script>
import {addVisitor, searchVisitor, visitorSearchByMatchName, visitorSearchByPhoneNo} from "@/api/visitor-api";
import {Apply} from "@/entity/entity";
import {getDataYMD} from "@/utils/commonUtils";

export default {
  name: "RegisterVisitorView",
  props: ["visitorSetting"],
  data() {
    return {
      visitorList: [],
      selectVisitorList: [],
      showCheckbox: false,
      showArriveStatus: false,
      showRemove: true,
      extCardNoDisabled: false,

      addDrawerShow: false,
      drawerActiveTab: "first",
      provideSearchForm: {
        searchInput: "",
        searchType: "company", // company, name, cardNo
      },
      providerRules: {
        searchType: [{required: true, message: "请选择搜索类型", trigger: 'change'}],
        searchInput: [{required: true, message: "请输入搜索内容", trigger: 'blur'}]
      },
      visitorSearch: {
        searchInput: "",
      },
      provideSearchResult: [],
      searchVisitorResult: [],
      newVisitor: {name: '', tel: '', ic: '', company: '', nationality: "中国"},
      visitorRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {type: 'string', pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        company: [
          {required: true, message: '请输入来访单位', trigger: 'blur'}
        ]
      },

      addVisitorType: "",// main peer
      selectType: "apply", // apply record
    }
  },
  mounted() {

  },
  watch: {
    "newVisitor.tel"(val) {
      if (val.length === 11 && !isNaN(val)) {
        this.searchPhoneNo(val)
      }
    },
    "visitorSearch.searchInput"(val) {
      if(isNaN(val)) {
        if (val.length > 0) {
          this.onSearchVisitor()
        }
      } else {
        if (val.length === 11) {
          this.onSearchVisitor()
        }
      }
    }
  },
  methods: {

    /**
     * called by parent
     * @param isMain
     */
    onAddVisitor(isMain) {
      this.addVisitorType = isMain ? "main" : "peer"
      this.newVisitor = {name: '', tel: '', company: '', ic: "", nationality: "中国"}
      this.provideSearchForm = {searchInput: "", searchType: "company"}
      this.searchVisitorResult = []
      this.provideSearchResult = []
      this.drawerActiveTab = 'first'
      this.visitorSearch.searchInput = ""

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.addDrawerShow = true
    },

    onGetRecord(record, curVisitor) {
      console.log("RegisterVisitorView onGetRecord", record, curVisitor)
      if (!record.apply) {
        return
      }
      this.extCardNoDisabled = true
      this.selectType = "record"
      this._getApply(record.apply, curVisitor, record.enterDate)
    },
    async onGetHistory(record, curVisitor) {
      console.log("RegisterVisitorView onGetRecord", record, curVisitor)
      this.showCheckbox = false
      this.showArriveStatus = false
      this.showRemove = true
      this.extCardNoDisabled = false

      let applyObj = new Apply(record.apply)
      let visitorList = await applyObj.manageGetShowVisitorList()
      this.visitorList = []
      visitorList.forEach(item => {
        if (item.id !== curVisitor.id) {
          if (item.type === "provider" && item.cardNo) {
            item.registerCardNo = item.cardNo
          }
          this.visitorList.push(item)
        }
      })
      this.handleSelectionChange(this.visitorList)
    },

    async onGetApplyHistory(apply, curVisitor) {
      console.log("RegisterVisitorView onGetApplyHistory", apply, curVisitor)
      this.showCheckbox = false
      this.showArriveStatus = false
      this.showRemove = true
      this.extCardNoDisabled = false

      let applyObj = new Apply(apply)
      let visitorList = await applyObj.manageGetShowVisitorList()
      this.visitorList = []
      visitorList.forEach(item => {
        if (item.id !== curVisitor.id) {
          this.visitorList.push(item)
        }
      })
      this.handleSelectionChange(this.visitorList)
    },

    onGetApply(apply, curVisitor) {
      this.extCardNoDisabled = false
      let date = new Date()
      let enterDate = getDataYMD(date)
      this.selectType = "apply"
      // let enterDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
      this._getApply(apply, curVisitor, enterDate)
    },

    async _getApply(apply, curVisitor, enterDate) {
      this.showCheckbox = true
      this.showArriveStatus = true
      this.showRemove = false

      let applyObj = new Apply(apply)
      await applyObj.manageDoCheckRecordState(enterDate)
      let visitorList = applyObj.accompanyList
      this.visitorList = []
      let selectVisitor = null
      visitorList.forEach(item => {
        if (item.arriveState !== "LEAVE") {
          this.visitorList.push(item)
        }
        if (item.id === curVisitor.id) {
          selectVisitor = item
        }
      })
      this.$nextTick(() => {
        this.$refs.visitorTable.clearSelection()
        if (selectVisitor && this.visitorList.length === 1) {
          this.$refs.visitorTable.toggleRowSelection(selectVisitor)
        } else {
          this.$nextTick(() => {
            this.handleSelectionChange([])
          })
        }
      })
    },

    onVisitorDel(row) {
      let findIndex = this.visitorList.findIndex(item => item.id === row.id)
      this.visitorList.splice(findIndex, 1)
      this.handleSelectionChange(this.visitorList)
    },
    handleSelectionChange(selectVisitorList) {
      this.selectVisitorList = selectVisitorList
      this.$emit("visitorSelectChange", selectVisitorList)
    },
    onDrawerSelectVisitor(visitor) {
      this.onAddOneVisitor(visitor)
    },

    onAddOneVisitor(visitor) {
      let find = this.visitorList.find(item => item.id === visitor.id)
      if (find) {
        this.$message.warning("该访客已存在")
        return
      }
      if (visitor.type === "provider") {
        visitor.registerCardNo = visitor.cardNo

      }
      this.visitorList.push(visitor)
      this.$message.success("访客添加成功")
      this.handleSelectionChange(this.visitorList)
    },

    onSearchProvideVisitor() {
      if (!this.provideSearchForm.searchInput) {
        this.$message.error("请输入搜索内容")
        return
      }
      this.provideSearchResult = []
      let postData = {type: "provider",}
      if (this.provideSearchForm.searchType === "company") {
        postData.company = this.provideSearchForm.searchInput
      } else if (this.provideSearchForm.searchType === "name") {
        postData.name = this.provideSearchForm.searchInput
      } else if (this.provideSearchForm.searchType === "cardNo") {
        postData.cardNo = this.provideSearchForm.searchInput
      }
      searchVisitor(postData).then(({data}) => {
        if (data.code === 200) {
          this.provideSearchResult = data.data
        }
      }).catch(err => {
        console.error("searchVisitor err", err)
      })
    },

    onDrawerAddVisitor() {
      if (this.newVisitor.data && this.newVisitor.tel === this.newVisitor.data.tel) {
        this.onAddOneVisitor(this.newVisitor.data)
        this.onNewAddSuccess()
        return
      }

      this.$refs.drawerForm.validate().then((validate) => {
        if (validate) {
          let postData = {
            name: this.newVisitor.name,
            tel: this.newVisitor.tel,
            company: this.newVisitor.company,
            ic: this.newVisitor.ic,
            nationality: this.newVisitor.nationality,
            type: 'common'
          }
          addVisitor(postData).then(({data}) => {
            if (data.code === 200) {
              this.onAddOneVisitor(data.data)
              this.onNewAddSuccess()
            } else {
              console.warn("visitorLogin false", data.code, data.msg)
              this.$message.success("添加失败，请检查填写信息")
            }
          }).catch(err => {
            console.error("visitorLogin err", err)
          })
        }
      }).catch(() => {
        console.log("onDrawerAddVisitor validate err")
      })
    },

    onNewAddSuccess() {
      this.newVisitor = {name: '', tel: '', company: '', ic: "", nationality: "中国"}
    },

    onSearchVisitor() {
      this.searchVisitorResult = []
      if (!this.visitorSearch.searchInput) {
        return
      }
      let searchFunc = visitorSearchByMatchName
      if (!isNaN(this.visitorSearch.searchInput)) {
        searchFunc = visitorSearchByPhoneNo
      }
      searchFunc(this.visitorSearch.searchInput).then(({data}) => {
        if (data.code === 200 && data.data.length > 0) {
          this.searchVisitorResult = data.data
        }
      }).catch(err => {
        console.log("search visitor ", err)
      })

    },

    reset() {
      this.visitorList = []
      this.selectVisitorList = []
      this.showCheckbox = false
      this.showArriveStatus = false
      this.showRemove = true
      this.extCardNoDisabled = false
      this.addDrawerShow = false
      this.addVisitorType = ""

    },

    searchPhoneNo(tel) {
      if (this.newVisitor.data && this.newVisitor.data.tel === tel) {
        return
      }
      this.newVisitor.data = null
      visitorSearchByPhoneNo(tel).then(({data}) => {
        if (data.code === 200 && data.data.length > 0) {
          let visitor = data.data[0]
          this.newVisitor.name = visitor.name
          this.newVisitor.tel = visitor.tel
          this.newVisitor.company = visitor.company
          this.newVisitor.ic = visitor.ic
          this.newVisitor.nationality = visitor.nationality
          this.newVisitor.data = visitor
        }
      }).catch(err => {
        console.log("visitorSearchByPhoneNo", err)
      })
    },

    selectable(row, index) {
      console.log("selectable ------- ", row, index)
      switch (this.selectType) {
        case "apply":
          return row.arriveState === "NO"
        case "record":
          return row.arriveState === "ENTER"
        default:
          return false
      }
    }

  }
}
</script>

<template>
  <div>
    <el-table class="main-table" ref="visitorTable" :data="visitorList" border @selection-change="handleSelectionChange" empty-text="暂无访客">
      <el-table-column type="selection" width="55" v-if="showCheckbox" key="0" align="center" :selectable="selectable"></el-table-column>
      <el-table-column label="到访状态" prop="enterCardNo" width="95" v-if="showArriveStatus" key="1" align="center">
        <template v-slot="scope">
          <el-tag type="danger">{{ scope.row.getShowArriveState() }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="mainType" label="访客类型" width="95" v-if="showArriveStatus" key="2" align="center">
        <template v-slot="scope">
          <el-tag v-if="scope.row.isMainVisitor">主访人</el-tag>
          <el-tag v-else> 同行人</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="访客姓名" width="105" key="3" align="center"></el-table-column>
      <el-table-column prop="tel" label="访客手机" width="160" key="4" align="center"></el-table-column>
      <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1" key="5" align="center">
        <template v-slot="scope">
          {{ scope.row.ic  | icNoFilter}}
        </template>
      </el-table-column>
      <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 " width="105" key="6" align="center"></el-table-column>
      <el-table-column label="分配卡号" prop="enterCardNo" width="130" v-if="extCardNoDisabled" key="7" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.registerCardNo">{{scope.row.registerCardNo}}</span>
          <span v-else>{{scope.row.enterCardNo}}</span>
        </template>
      </el-table-column>
      <el-table-column label="分配卡号" prop="registerCardNo" width="130" v-else key="8" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.enterCardNo">{{scope.row.enterCardNo}}</span>
          <el-input v-else v-model="scope.row.registerCardNo" class="w-full" :disabled="scope.row.type === 'provider'"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="company" label="访客公司" key="9" align="center"></el-table-column>
      <el-table-column label="操作" width="100" v-if="showRemove" key="10" align="center">
        <template v-slot="scope">
          <el-button type="danger" @click="onVisitorDel(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :visible.sync="addDrawerShow" :with-header="false" :append-to-body="true"
               :close-on-click-modal="false" size="800px">
      <el-container>
        <el-tabs v-model="drawerActiveTab" :stretch="true" class="w-full">
          <el-tab-pane label="供应商访客" name="first">
            <div class="content px-0">
              <el-main style="padding: 0 0 0 0" class="drawer-form-box">

                <div class="flex flex-col justify-center pb-4">
                  <div class="font-bold text-xl">供应商中选择</div>
                </div>

                <el-form class="main-form flex m-0 w-full" label-width="115px" :inline="true" :model="provideSearchForm" :rules="providerRules" @submit.native.prevent>
                  <el-form-item label="搜索方式" prop="searchType" class="">
                    <el-select v-model="provideSearchForm.searchType" placeholder="请选择搜索方式" style="width: 275px">
                      <el-option label="企业名称" value="company"></el-option>
                      <el-option label="人员姓名" value="name"></el-option>
                      <el-option label="访客卡号" value="cardNo"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="搜索内容" prop="searchInput" class="">
                    <el-input v-model="provideSearchForm.searchInput" placeholder="请输入搜索内容" style="width: 275px">
                      <el-button slot="append" icon="el-icon-search" @click="onSearchProvideVisitor"></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="size-2"></div>
                <el-table class="main-table drawer-table" :data="provideSearchResult" ref="multipleTable" border size="mini">
                  <el-table-column prop="name" label="访客姓名"></el-table-column>
                  <el-table-column prop="cardNo" label="访客卡号"></el-table-column>
                  <el-table-column prop="company" label="访客公司"></el-table-column>
                  <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
                    <template v-slot="scope">
                      {{ scope.row.ic  | icNoFilter}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1"></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template v-slot="scope">
                      <el-button type="success" @click="onDrawerSelectVisitor(scope.row)">选择</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
            </div>
          </el-tab-pane>

          <el-tab-pane label="非供应商访客" name="second">
            <el-main style="padding: 0 0 0 0" class="drawer-form-box">

              <div class="flex flex-col justify-center pb-4">
                <div class="font-bold text-xl">添加访客</div>
              </div>
              <el-form ref="drawerForm" :model="newVisitor" label-width="115px" class="main-form flex flex-row flex-wrap" :rules="visitorRules">
                <el-form-item label="访客姓名" prop="name" class="w-1/2">
                  <el-input v-model="newVisitor.name" placeholder="请输入姓名" class="table-width-drawer"></el-input>
                </el-form-item>
                <el-form-item label="访客手机" prop="tel" class="w-1/2">
                  <el-input v-model="newVisitor.tel" placeholder="请输入手机号" class="table-width-drawer"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="ic" v-if="visitorSetting.idCardNo !== 1" class="w-1/2">
                  <el-input v-model="newVisitor.ic" placeholder="请输入身份证号" class="table-width-drawer"></el-input>
                </el-form-item>
                <el-form-item label="访客国籍" prop="nationality" v-if="visitorSetting.nationality !== 1 " class="w-1/2">
                  <el-input v-model="newVisitor.nationality" placeholder="请输入访客国籍" class="table-width-drawer"></el-input>
                </el-form-item>
                <el-form-item label="访客公司" prop="company" class="w-1/2">
                  <el-input v-model="newVisitor.company" placeholder="请输入公司名称" class="table-width-drawer"></el-input>
                </el-form-item>
                <el-form-item class="w-full">
                  <el-button style="margin-left: 250px" type="primary" @click="onDrawerAddVisitor">添加访客</el-button>
                </el-form-item>
              </el-form>
              <div style="height: 1px; width: 100%; background-color: #efefef; margin-top: 10px; margin-bottom: 10px"></div>
              <div class="flex flex-col justify-center py-4">
                <div class="font-bold text-xl">搜索选择访客</div>
              </div>
              <el-form :model="visitorSearch" class="main-form" @submit.native.prevent>
                <el-form-item label="搜索访客" prop="company" label-width="115px" class="drawer-form">
                  <el-input v-model="visitorSearch.searchInput" placeholder="请输入访客姓名或手机号" class="table-width-drawer">
                    <el-button slot="append" icon="el-icon-search" @click="onSearchVisitor"></el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <el-table class="main-table bottom-table " :data="searchVisitorResult" ref="multipleTable" border >
                <el-table-column prop="name" label="访客姓名"></el-table-column>
                <el-table-column prop="tel" label="访客手机"></el-table-column>
                <el-table-column prop="company" label="访客公司"></el-table-column>
                <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
                  <template v-slot="scope">
                    {{ scope.row.ic  | icNoFilter}}
                  </template>
                </el-table-column>
                <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 "></el-table-column>
                <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-button type="success" @click="onDrawerSelectVisitor(scope.row)">选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>

          </el-tab-pane>
        </el-tabs>


        <el-footer class="center">
          <el-button @click="addDrawerShow = false">取 消</el-button>
        </el-footer>
      </el-container>
    </el-drawer>

  </div>
</template>

<style scoped lang="less">
.content {
  width: 800px;
  text-align: center;
}

.center {
  text-align: center;
  padding: 15px;
}

.drawer-form-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  height: calc(100vh - 120px);

}

.main-table {
  font-size: 20px;

  .el-input {
    font-size: 20px;

  }
}

.main-form {
  /deep/ .el-form-item__label {
    font-size: 20px;
  }

  .el-radio {
    height: 42px;
    line-height: 42px;
  }

  /deep/ .el-radio__label {
    font-size: 20px;
  }

  .el-select {
    width: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 20px;

  }
}

/deep/ .el-table thead {
  font-size: 20px;
  color: #606266;
  font-weight: 400;
}
.bottom-table {
  height:  800px;
  overflow-y: auto;
}
</style>
